export default __webpack_public_path__ + "static/media/a023-short2.39846a1c.jpg";